import { render, staticRenderFns } from "./banner-text.vue?vue&type=template&id=2e2526f4&scoped=true&"
import script from "./banner-text.vue?vue&type=script&lang=js&"
export * from "./banner-text.vue?vue&type=script&lang=js&"
import style0 from "./banner-text.vue?vue&type=style&index=0&id=2e2526f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2526f4",
  null
  
)

export default component.exports